import Search from 'src/shared/ui/Search/Search';
import styled from 'styled-components';

export const StyledSearch = styled(Search)`
  margin-bottom: 16px;
`;
